import { IonCol, IonImg, IonModal, IonRow } from "@ionic/react";
import React, { useEffect, useRef, useState } from "react";
import ExerciseDetailModal from "./modals/ExerciseDetailModal";
import CustomSearchBar from "./CustomSearchBar";
import {
  SaveRecentExerciseSearch,
  GetExercisesLookupDetails,
  GetFilteredExercises,
} from "../services/ExercisesService";
import { useHistory } from "react-router-dom";
import { ActionType } from "../models/Enums";
import {
  allExercisesState,
  fixedAllExercisesState,
  isDuplicateCalledState,
  lookupDetailsState,
} from "../data/atoms";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  duplicateExercisePlanState,
  newDuplicateExercisePlanState,
  tempAllExercisesState,
} from "../data/atoms";
import ExerciseFilterModal from "./modals/ExerciseFilterModal";
import { sortTests } from "../utils/sharedFunction";

interface Props {
  exercisesList: any;
  hideShowFooter: Function;
  selectedExercisesid: number[];
  previousExercises: any;
  isDuplicatePlanCalled: boolean;
  isRTMEnabled: boolean;
  onCountChange?: (count: number) => void;
}
const ExerciseCard: React.FC<Props> = ({
  exercisesList,
  hideShowFooter,
  selectedExercisesid,
  previousExercises,
  isDuplicatePlanCalled,
  isRTMEnabled,
  onCountChange,
}) => {
  const [selected, setSelected] = useState<number[]>([]);

  let history = useHistory();
  const [selectedExerciseId, setSelectedExerciseId] =
    useState<number[]>(selectedExercisesid);
  const [selectedExerciseDetail, setSelectedExerciseDetail] = useState<any>();
  const [exerciseDetailModal, setExerciseDetailModal] = useState(false);
  const [filterSelecetd, setFilterSelected] = useState(false);
  const [selectedCount, showHideSelectedCount] = useState(false);
  const [exerciseFilterModal, setExerciseFilterModal] = useState(false);
  const searchResultRef = useRef<HTMLDivElement>(null);
  const [isOutsideClicked, setIsOutsideClicked] = useState<boolean>(false);
  const [duplicateExercisePlan, setDuplicateExercisePlan] = useRecoilState(
    duplicateExercisePlanState,
  );
  const [repduplicateExercisePlan, setRepDuplicateExercisePlan] = useState(
    duplicateExercisePlan,
  );
  const [isDuplicateCalled, setIsDuplicateCalled] = useRecoilState(
    isDuplicateCalledState,
  );
  const [newDuplicateExercisePlan, setNewDuplicateExercisePlan] =
    useRecoilState(newDuplicateExercisePlanState);
  const [selectedExerciseFromSearch, setSelectedExerciseFromSearch] =
    useState<any>();
  const [allExercises, setAllExercisesState] =
    useRecoilState(allExercisesState);
  const [allExercisesFilter, setAllExercisesFilterState] =
    useRecoilState(allExercisesState);
  const [fixedExercisesCount, setFixedExercisesCount] = useRecoilState(
    fixedAllExercisesState,
  );
  const [exeCount, setExeCount] = useState(0);
  const [searchText, setSearchText] = useState<string>("");
  const [exercisesLookupDetails, setExercisesLookupDetails] = useState<any>();
  const [lookupDetailsRecoil, setLookupDetailsRecoil] =
    useRecoilState(lookupDetailsState);
  const [filteredLookupDetails, setFilteredLookupDetails] = useState<any[]>([]);
  const [fixedPreviousExercises, setFixedPreviousExercises] = useState<any>();
  const [isFilterSelected, setIsFilterSelected] = useState(false);

  const [isNotCalledFromDuplicate, setIsNotCalledFromDuplicate] =
    useState(true);

  const [tempAllExercises, setTempAllExercises] = useRecoilState(
    tempAllExercisesState,
  );
  const [isRtmConfigurationEnabled, setIsRtmConfigurationEnabled] =
    useState(false);
  const rtmEnabledRef = useRef(false);

  // Clone the array to avoid mutating state directly
  const clonedArr: any = [...fixedExercisesCount.exercises];

  let selectedIds = duplicateExercisePlan.exercises.map(
    (exercise: any) => exercise.testExercises[0].id,
  );

  useEffect(() => {
    onCountChange?.(exeCount);
  }, [exeCount]);

  useEffect(() => {
    setIsNotCalledFromDuplicate(isDuplicatePlanCalled);
  }, [isDuplicatePlanCalled]);

  useEffect(() => {
    setAllExercisesFilterState(allExercises);
  }, [allExercises]);

  // Need to discuss with the Saad but it is preventing this Bug 24215: VSTBalance>Proactive Strides>Duplicate Exercises screen issues.
  // useEffect(() => {
  //   setFixedPreviousExercises(fixedExercisesCount.previouslySelectedExercises);
  // }, [previousExercises]);

  //To ensure that isDuplicateCalled is set to false when the user navigates to the full-visit-summary page
  useEffect(() => {
    const rtmEnabled = localStorage.getItem("isRtmEnabled") === "true";
    setIsRtmConfigurationEnabled(rtmEnabled);
    rtmEnabledRef.current = rtmEnabled;
    if (window.location.href.includes("/full-visit-summary")) {
      setIsDuplicateCalled(false);
    }
  }, []);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        searchResultRef.current &&
        !searchResultRef.current.contains(event.target as Node)
      ) {
        setIsOutsideClicked(true);
      } else {
        setIsOutsideClicked(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [searchResultRef]);

  const setFilterState = async (data: boolean) => {
    setIsFilterSelected(data);
  };

  const showExerciseDetailModal = (detail: any) => {
    setSelectedExerciseDetail(detail);
    setExerciseDetailModal(true);
  };

  const setCardSelected = (selectedExeId: number) => {
    debugger;
    setIsFilterSelected(false);
    setSelectedExerciseId((prevSelectedItems) => {
      if (prevSelectedItems.includes(selectedExeId)) {
        // Remove the item if it is already selected
        const newItem = prevSelectedItems.filter(
          (item) => item !== selectedExeId,
        );
        if (newItem.length === 0) {
          hideShowFooter(false);
          showHideSelectedCount(false);
        }
        return newItem;
      } else {
        // Add the item if it is not selected
        hideShowFooter(true);
        showHideSelectedCount(true);
        return [...prevSelectedItems, selectedExeId];
      }
    });
  };

  const setCardsSelected = (newSelectedIds: number[]) => {
    setSelectedExerciseId(() => {
      // If the new array is empty, hide the footer and the selected count
      if (newSelectedIds.length === 0) {
        hideShowFooter(false);
        showHideSelectedCount(false);
      } else {
        hideShowFooter(true);
        showHideSelectedCount(true);
      }
      // Replace the old state with the new state
      return newSelectedIds;
    });
  };

  const GetSearchText = (text: string) => {
    if (text === "") {
      const sortArr = sortTests(clonedArr, selectedIds);

      setTempAllExercises((prevState: any) => ({
        ...prevState,
        exercises: sortArr,
      }));

      setAllExercisesFilterState(fixedExercisesCount);
    }
    setSearchText(text);
  };

  const SaveRecentSearch = async (exercise: any) => {
    setSearchText(exercise.testName);
    setSelectedExerciseFromSearch(exercise);
    const obj = {
      ExercisesText: exercise.testName,
    };
    try {
      await SaveRecentExerciseSearch(obj)
        .then(async function (response: any) {
          const filteredExercise = fixedExercisesCount?.exercises.filter(
            (exercises: any) =>
              exercises.testName.toLowerCase() ===
              exercise.testName.toLowerCase(),
          );

          setTempAllExercises((prevState: any) => ({
            ...prevState,
            exercises: filteredExercise,
          }));

          setAllExercisesFilterState((prevState: any) => ({
            ...prevState,
            exercises: filteredExercise,
            recommendedExercisesBasedOnAssessment:
              fixedExercisesCount.recommendedExercisesBasedOnAssessment,
          }));
          setIsOutsideClicked(true);
        })
        .catch((error) => {
          history.push("/confirmation", {
            actionType: ActionType.FailureAPIResponse,
          });
          console.error(error);
        });
    } catch (error) {
      history.push("/confirmation", {
        actionType: ActionType.FailureAPIResponse,
      });
      console.error(error);
    }
  };
  useEffect(() => {
    debugger;
    let previousExercisesIds: number[] = [];
    if (
      !isDuplicateCalled &&
      exercisesList.previouslySelectedExercises &&
      exercisesList.previouslySelectedExercises.length > 0
    ) {
      exercisesList.previouslySelectedExercises.map((item: any) => {
        previousExercisesIds.push(item.testExercises[0].id);
      });
      setCardsSelected(previousExercisesIds);
    }
  }, [exercisesList.previouslySelectedExercises]);

  useEffect(() => {
    debugger;
    if (isDuplicateCalled) {
      debugger;
      const filterId = JSON.parse(localStorage.getItem("selectedExercises")!);
      const filteredList = allExercises.exercises.filter((item: any) =>
        filterId.includes(item.testExercises[0].id),
      );
      setDuplicateExercisePlan((prevState: any) => ({
        ...prevState,
        exercises: filteredList,
      }));
      setExeCount(filteredList.length);
    } else {
      debugger;
      setExeCount(selectedExerciseId.length);
      // console.log("selectedCount", selectedCount);
      const filteredList = exercisesList.exercises.filter((item: any) =>
        selectedExerciseId.includes(item.testExercises[0].id),
      );
      setDuplicateExercisePlan((prevState: any) => ({
        ...prevState,
        exercises: filteredList,
      }));
    }
    // setNewDuplicateExercisePlan((prevState: any) => ({
    //   ...prevState,
    //   exercises: filteredList,
    // }));
  }, [selectedExerciseId]);

  useEffect(() => {
    const obj = {};
    try {
      GetExercisesLookupDetails(obj)
        .then(async function (response: any) {
          // const sortOrder = ["Gait Test", "5x STS", "mCTSIB", "Reach", "TUG"];
          // if (response?.data?.assessmentAssociated) {
          //   response.data.assessmentAssociated.sort((a: any, b: any) => {
          //     const indexA = sortOrder.indexOf(a.name);
          //     const indexB = sortOrder.indexOf(b.name);
          //     if (indexA === -1 && indexB === -1) return 0;
          //     if (indexA === -1) return 1;
          //     if (indexB === -1) return -1;
          //     return indexA - indexB;
          //   });
          // }
          setExercisesLookupDetails(response?.data);
          setLookupDetailsRecoil(response?.data);
        })
        .catch((error) => {
          history.push("/confirmation", {
            actionType: ActionType.FailureAPIResponse,
          });
          console.error(error);
        });
    } catch (error) {
      history.push("/confirmation", {
        actionType: ActionType.FailureAPIResponse,
      });
      console.error(error);
    }
  }, []);

  useEffect(() => {
    setFilteredLookupDetails([]);

    const iterateThroughRecoilObject = (obj: any) => {
      Object.keys(obj).forEach((key) => {
        const value = obj[key];
        if (Array.isArray(value)) {
          value.forEach((item: any) => {
            if (item.isSelected) {
              setFilteredLookupDetails((prevState) => [...prevState, item]);
            }
          });
        }
      });
    };

    iterateThroughRecoilObject(lookupDetailsRecoil);
  }, [lookupDetailsRecoil]);

  const getFilteredExercises = async (ids: any) => {
    const obj = {
      PatientId: localStorage.getItem("patientServerID")!,
      FiltersValuesRegions: ids.regionId,
      FiltersValuesPositions: ids.positionsId,
      FiltersValuesTypes: ids.typesId,
      FiltersValuesAssessmentsAssociated: ids.assessmentAssociatedId,
      FiltersValuesMobilityLevel: ids.mobilityLevelId,
      SearchedExerciseName: "",
      ExercisesIds: "",
    };
    try {
      await GetFilteredExercises(obj)
        .then(async function (response: any) {
          const responseExercises = response.data.allExercisesList;
          // Extracting IDs from responseExercises
          const responseExerciseIds = responseExercises.map(
            (exercise: any) => exercise.testExercises[0].id,
          );

          // Filtering fixedExercisesCount.exercises based on the extracted IDs
          const filteredExerciseList = fixedExercisesCount.exercises.filter(
            (fixedExercise: any) =>
              responseExerciseIds.includes(fixedExercise.testExercises[0].id),
          );

          const sortArr = sortTests(clonedArr, selectedIds);

          setTempAllExercises((prevState: any) => ({
            ...prevState,
            exercises: sortArr,
          }));

          setAllExercisesFilterState((prevState: any) => ({
            ...prevState,
            exercises: filteredExerciseList,
            exercisesRecommendationHistory:
              fixedExercisesCount.exercisesRecommendationHistory,
            recommendedExercisesBasedOnAssessment:
              fixedExercisesCount.recommendedExercisesBasedOnAssessment,
            sidesLookup: fixedExercisesCount.sidesLookup,
            patientDetails: fixedExercisesCount.patientDetails,
            previouslySelectedExercises:
              fixedExercisesCount.previouslySelectedExercises,
          }));
        })
        .catch((error) => {
          console.error(error);
        });
    } catch (error) {
      console.error(error);
    }
  };

  const handleFilterClick = async (item: any) => {
    debugger;
    let isFound: boolean = false;
    let updatedData: any = [];
    let filterType = "";

    const toggleSelection = (dataArray: any[], type: string) => {
      if (isFound) return dataArray;
      return dataArray.map((r: any) => {
        if (r.name === item.name) {
          isFound = true;
          filterType = type;
          return { ...r, isSelected: !r.isSelected };
        }
        return r;
      });
    };

    updatedData = toggleSelection(lookupDetailsRecoil?.regions, "regions");
    updatedData = isFound
      ? updatedData
      : toggleSelection(lookupDetailsRecoil?.positions, "positions");
    updatedData = isFound
      ? updatedData
      : toggleSelection(lookupDetailsRecoil?.types, "types");
    updatedData = isFound
      ? updatedData
      : toggleSelection(
          lookupDetailsRecoil?.assessmentAssociated,
          "assessmentAssociated",
        );
    updatedData = isFound
      ? updatedData
      : toggleSelection(lookupDetailsRecoil?.mobilityLevel, "mobilityLevel");

    const newLookupDetailsRecoil = {
      ...lookupDetailsRecoil,
      [filterType]: updatedData,
    };

    setLookupDetailsRecoil(newLookupDetailsRecoil);
    await filterExercises(newLookupDetailsRecoil);
  };

  const filterExercises = async (updatedLookupDetails: any) => {
    let obj = {
      regions: updatedLookupDetails?.regions.filter((r: any) => r.isSelected),
      positions: updatedLookupDetails?.positions.filter(
        (r: any) => r.isSelected,
      ),
      types: updatedLookupDetails?.types.filter((r: any) => r.isSelected),
      assessmentAssociated: updatedLookupDetails?.assessmentAssociated.filter(
        (r: any) => r.isSelected,
      ),
      mobilityLevel: updatedLookupDetails?.mobilityLevel.filter(
        (r: any) => r.isSelected,
      ),
    };
    let extractedIds = extractIdsFromFilters(obj);
    if (
      obj.regions.length === 0 &&
      obj.positions.length === 0 &&
      obj.types.length === 0 &&
      obj.assessmentAssociated.length === 0 &&
      obj.mobilityLevel.length === 0
    ) {
      setIsFilterSelected(false);
    }
    await getFilteredExercises(extractedIds);
    setLookupDetailsRecoil(updatedLookupDetails);
  };

  const extractIdsFromFilters = (data: any) => {
    let idsByKey: any = {};
    idsByKey.regionId = data.regions.map((item: any) => item.id).join(",");
    idsByKey.positionsId = data.positions.map((item: any) => item.id).join(",");
    idsByKey.typesId = data.types.map((item: any) => item.id).join(",");
    idsByKey.assessmentAssociatedId = data.assessmentAssociated
      .map((item: any) => item.id)
      .join(",");
    idsByKey.mobilityLevelId = data.mobilityLevel
      .map((item: any) => item.id)
      .join(",");
    return idsByKey;
  };

  const handleCardClick = (e: React.MouseEvent<HTMLElement>, id: number) => {
    if ((e.target as HTMLElement).closest("svg")) {
      // If the clicked element is an SVG or within an SVG, do nothing
      return;
    }

    setCardSelected(id);
  };

  return (
    <>
      <IonModal
        className="all-generic-new-modal-center-main-wrap"
        backdropDismiss={false}
        isOpen={exerciseDetailModal}
        placeholder={undefined}
      >
        <ExerciseDetailModal
          selectedExerciseDetail={selectedExerciseDetail}
          setExerciseDetailModal={setExerciseDetailModal}
        ></ExerciseDetailModal>
      </IonModal>

      <IonModal
        className="exercise-filter-modal-main-wrap"
        backdropDismiss={false}
        isOpen={exerciseFilterModal}
        placeholder={undefined}
      >
        <ExerciseFilterModal
          exerciseFilterModal={setExerciseFilterModal}
          exercisesLookupDetails={exercisesLookupDetails}
          setIsFilterSelected={setFilterState}
        ></ExerciseFilterModal>
      </IonModal>
      <IonRow className="row" placeholder={undefined}>
        <IonCol className="col-sec" placeholder={undefined}>
          <div className="search-exercise-sec">
            <h3>Exercise Search</h3>
            <span ref={searchResultRef}>
              <CustomSearchBar
                exercisesList={exercisesList?.exercises}
                clickedOutside={isOutsideClicked}
                getSelectedExercise={SaveRecentSearch}
                getSearchText={GetSearchText}
              />
            </span>
          </div>

          <div className="filter-main-wrap">
            <ul>
              <li
                onClick={() => {
                  setExerciseFilterModal(true);
                }}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15 11a4.002 4.002 0 0 1-3.874-3H3a1 1 0 0 1 0-2h8.126a4.002 4.002 0 0 1 7.748 0H21a1 1 0 1 1 0 2h-2.126A4.002 4.002 0 0 1 15 11zM3 16a1 1 0 1 0 0 2h2.126a4.002 4.002 0 0 0 7.748 0H21a1 1 0 1 0 0-2h-8.126a4.002 4.002 0 0 0-7.748 0H3zm12-7a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm-4 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0z"
                    fill="#ffffff"
                  />
                </svg>
                <span>Filters ({filteredLookupDetails.length})</span>
              </li>
              {filteredLookupDetails.map((item, index) => (
                <li key={index}>
                  <span>{item.name}</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    onClick={() => handleFilterClick(item)}
                  >
                    <path
                      d="M5.64338 10.3571L10.3574 5.64307"
                      stroke="#002E3C"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    />
                    <path
                      d="M5.64338 5.64289L10.3574 10.3569"
                      stroke="#002E3C"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    />
                  </svg>
                </li>
              ))}
            </ul>
          </div>

          {rtmEnabledRef.current && isRTMEnabled && (
            <div className="mb-24 d-flex align-items-center gap-8">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="21"
                viewBox="0 0 20 21"
                fill="none"
              >
                <path
                  d="M10 20.5C7.34784 20.5 4.8043 19.4464 2.92893 17.5711C1.05357 15.6957 0 13.1522 0 10.5C0 7.84784 1.05357 5.3043 2.92893 3.42893C4.8043 1.55357 7.34784 0.5 10 0.5C12.6522 0.5 15.1957 1.55357 17.0711 3.42893C18.9464 5.3043 20 7.84784 20 10.5C20 13.1522 18.9464 15.6957 17.0711 17.5711C15.1957 19.4464 12.6522 20.5 10 20.5ZM10 13C9.66848 13 9.35054 13.1317 9.11612 13.3661C8.8817 13.6005 8.75 13.9185 8.75 14.25C8.75 14.5815 8.8817 14.8995 9.11612 15.1339C9.35054 15.3683 9.66848 15.5 10 15.5C10.3315 15.5 10.6495 15.3683 10.8839 15.1339C11.1183 14.8995 11.25 14.5815 11.25 14.25C11.25 13.9185 11.1183 13.6005 10.8839 13.3661C10.6495 13.1317 10.3315 13 10 13ZM10 5.5C9.28906 5.5 8.72266 6.10547 8.77344 6.81641L9.0625 10.8789C9.09766 11.3711 9.50781 11.75 9.99609 11.75C10.4883 11.75 10.8945 11.3711 10.9297 10.8789L11.2188 6.81641C11.2695 6.10547 10.707 5.5 9.99219 5.5H10Z"
                  fill="#005A75"
                />
              </svg>

              <h6 className="fz-18 fw-600 mb-0 text-charcoal-blue ">
                RTM is enabled. Please add 2 or more exercises to continue.
              </h6>
            </div>
          )}
        </IonCol>
      </IonRow>

      {exercisesList.exercises && exeCount > 0 && <h5>{exeCount} Selected</h5>}
      <div
        className={
          selectedExerciseId.length > 0
            ? "exercise-list-main-parent-wrap footer-active"
            : "exercise-list-main-parent-wrap"
        }
      >
        {isNotCalledFromDuplicate
          ? allExercisesFilter &&
            allExercisesFilter.exercises.map((exercise: any) => {
              return (
                <div
                  className="exercise-list-main-wrap"
                  key={exercise.testName}
                >
                  {exercisesList.recommendedExercisesBasedOnAssessment !==
                    null &&
                    exercisesList.recommendedExercisesBasedOnAssessment.length >
                      0 &&
                    exercise.testExercises[0].isLastVisitRecommendedExercise &&
                    (exercise.testExercises[0].isGait ||
                      exercise.testExercises[0].is5XSTS ||
                      exercise.testExercises[0].ismCTSIB ||
                      exercise.testExercises[0].isTug ||
                      exercise.testExercises[0].isReach) && (
                      <div
                        className="suggestion-area-wrap"
                        key={exercise.testExercises[0].id}
                      >
                        <div className="text-area">
                          <h3>Suggested</h3>
                        </div>
                        <div className="ex-name">
                          <ul>
                            {exercise.testExercises[0].isGait && (
                              <li>
                                Gait
                                {exercisesList.recommendedExercisesBasedOnAssessment.map(
                                  (rec: any, index: number) => {
                                    if (rec.vbTestLookupId === 22) {
                                      return (
                                        <span
                                          key={index}
                                          className={
                                            rec.mobility === "high"
                                              ? "ex-green"
                                              : rec.mobility === "medium"
                                                ? "ex-orange"
                                                : rec.mobility === "low" ||
                                                    rec.mobility === "ultralow"
                                                  ? "ex-red"
                                                  : ""
                                          }
                                        ></span>
                                      );
                                    }
                                  },
                                )}
                              </li>
                            )}
                            {exercise.testExercises[0].is5XSTS && (
                              <li>
                                5x-STS
                                {exercisesList.recommendedExercisesBasedOnAssessment.map(
                                  (rec: any, index: number) => {
                                    if (rec.vbTestLookupId === 35) {
                                      return (
                                        <span
                                          key={index}
                                          className={
                                            rec.mobility === "high"
                                              ? "ex-green"
                                              : rec.mobility === "medium"
                                                ? "ex-orange"
                                                : rec.mobility === "low" ||
                                                    rec.mobility === "ultralow"
                                                  ? "ex-red"
                                                  : ""
                                          }
                                        ></span>
                                      );
                                    }
                                  },
                                )}
                              </li>
                            )}
                            {exercise.testExercises[0].ismCTSIB && (
                              <li>
                                mCTSIB
                                {exercisesList.recommendedExercisesBasedOnAssessment.map(
                                  (rec: any, index: number) => {
                                    if (rec.vbTestLookupId === 1) {
                                      return (
                                        <span
                                          key={index}
                                          className={
                                            rec.mobility === "high"
                                              ? "ex-green"
                                              : rec.mobility === "medium"
                                                ? "ex-orange"
                                                : rec.mobility === "low" ||
                                                    rec.mobility === "ultralow"
                                                  ? "ex-red"
                                                  : ""
                                          }
                                        ></span>
                                      );
                                    }
                                  },
                                )}
                              </li>
                            )}
                            {exercise.testExercises[0].isTug && (
                              <li>
                                Tug
                                {exercisesList.recommendedExercisesBasedOnAssessment.map(
                                  (rec: any, index: number) => {
                                    if (rec.vbTestLookupId === 31) {
                                      return (
                                        <span
                                          key={index}
                                          className={
                                            rec.mobility === "high"
                                              ? "ex-green"
                                              : rec.mobility === "medium"
                                                ? "ex-orange"
                                                : rec.mobility === "low" ||
                                                    rec.mobility === "ultralow"
                                                  ? "ex-red"
                                                  : ""
                                          }
                                        ></span>
                                      );
                                    }
                                  },
                                )}
                              </li>
                            )}
                            {exercise.testExercises[0].isReach && (
                              <li>
                                Reach
                                {exercisesList.recommendedExercisesBasedOnAssessment.map(
                                  (rec: any, index: number) => {
                                    if (rec.vbTestLookupId === 2) {
                                      return (
                                        <span
                                          key={index}
                                          className={
                                            rec.mobility === "high"
                                              ? "ex-green"
                                              : rec.mobility === "medium"
                                                ? "ex-orange"
                                                : rec.mobility === "low" ||
                                                    rec.mobility === "ultralow"
                                                  ? "ex-red"
                                                  : ""
                                          }
                                        ></span>
                                      );
                                    }
                                  },
                                )}
                              </li>
                            )}
                          </ul>
                        </div>
                      </div>
                    )}
                  <div
                    className={
                      selectedExerciseId.includes(exercise.testExercises[0].id)
                        ? "exercise-main-card-wrap selected"
                        : "exercise-main-card-wrap"
                    }
                    onClick={(e) =>
                      handleCardClick(e, exercise.testExercises[0].id)
                    }
                  >
                    <div
                      className="q-mark-icon"
                      onClick={() => showExerciseDetailModal(exercise)}
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle
                          cx="10"
                          cy="10"
                          r="9.05"
                          fill="white"
                          stroke="#31344E"
                          strokeWidth="1.9"
                        />
                        <path
                          d="M10.508 12.3391H8.46477C8.47011 11.8583 8.50751 11.4444 8.57695 11.0971C8.65173 10.7446 8.77727 10.4267 8.95355 10.1436C9.13517 9.8605 9.37555 9.58006 9.6747 9.30228C9.92576 9.07793 10.1448 8.86425 10.3317 8.66126C10.5187 8.45827 10.6656 8.24994 10.7724 8.03627C10.8793 7.81725 10.9327 7.5742 10.9327 7.30711C10.9327 6.99728 10.8846 6.74088 10.7885 6.53789C10.6977 6.32956 10.5588 6.17197 10.3718 6.06513C10.1902 5.9583 9.96048 5.90488 9.68271 5.90488C9.45301 5.90488 9.23934 5.95563 9.04169 6.05712C8.84404 6.15327 8.68111 6.30285 8.55291 6.50584C8.43005 6.70883 8.36595 6.97592 8.36061 7.30711H6.03691C6.05293 6.57528 6.2212 5.97165 6.54171 5.49623C6.86756 5.01547 7.30292 4.66023 7.84779 4.43053C8.39266 4.19549 9.0043 4.07797 9.68271 4.07797C10.4306 4.07797 11.0716 4.20084 11.6058 4.44656C12.1399 4.68694 12.5486 5.04217 12.8317 5.51226C13.1148 5.97699 13.2564 6.54323 13.2564 7.21096C13.2564 7.6757 13.1656 8.08969 12.984 8.45293C12.8023 8.81084 12.5646 9.1447 12.2708 9.45453C11.977 9.76435 11.6538 10.0849 11.3013 10.4161C10.9968 10.6885 10.7885 10.9743 10.6763 11.2734C10.5695 11.5726 10.5134 11.9278 10.508 12.3391ZM8.22439 14.8151C8.22439 14.4732 8.34191 14.1901 8.57695 13.9657C8.81199 13.736 9.12716 13.6212 9.52245 13.6212C9.91241 13.6212 10.2249 13.736 10.4599 13.9657C10.7003 14.1901 10.8205 14.4732 10.8205 14.8151C10.8205 15.1462 10.7003 15.4267 10.4599 15.6564C10.2249 15.8861 9.91241 16.0009 9.52245 16.0009C9.12716 16.0009 8.81199 15.8861 8.57695 15.6564C8.34191 15.4267 8.22439 15.1462 8.22439 14.8151Z"
                          fill="#31344E"
                        />
                      </svg>
                    </div>
                    <div className="img-sec">
                      <IonImg
                        src={exercise.testExercises[0].thumbnail}
                        placeholder={undefined}
                      ></IonImg>
                    </div>
                    <div className="text-sec">
                      <h2>{exercise.testName}</h2>
                    </div>
                  </div>
                </div>
              );
            })
          : tempAllExercises &&
            tempAllExercises.exercises?.map((exercise: any) => {
              // consoleExercises(exercise);
              return (
                <div
                  className="exercise-list-main-wrap"
                  key={exercise.testName}
                >
                  {exercisesList.recommendedExercisesBasedOnAssessment !==
                    null &&
                    exercisesList.recommendedExercisesBasedOnAssessment.length >
                      0 &&
                    exercise.testExercises[0].isLastVisitRecommendedExercise &&
                    (exercise.testExercises[0].isGait ||
                      exercise.testExercises[0].is5XSTS ||
                      exercise.testExercises[0].ismCTSIB ||
                      exercise.testExercises[0].isTug ||
                      exercise.testExercises[0].isReach) && (
                      <div
                        className="suggestion-area-wrap"
                        key={exercise.testExercises[0].id}
                      >
                        <div className="text-area">
                          <h3>Suggested</h3>
                        </div>
                        <div className="ex-name">
                          <ul>
                            {exercise.testExercises[0].isGait && (
                              <li>
                                Gait
                                {exercisesList.recommendedExercisesBasedOnAssessment.map(
                                  (rec: any, index: number) => {
                                    if (rec.vbTestLookupId === 22) {
                                      return (
                                        <span
                                          key={index}
                                          className={
                                            rec.mobility === "high"
                                              ? "ex-green"
                                              : rec.mobility === "medium"
                                                ? "ex-orange"
                                                : rec.mobility === "low" ||
                                                    rec.mobility === "ultralow"
                                                  ? "ex-red"
                                                  : ""
                                          }
                                        ></span>
                                      );
                                    }
                                  },
                                )}
                              </li>
                            )}
                            {exercise.testExercises[0].is5XSTS && (
                              <li>
                                5x-STS
                                {exercisesList.recommendedExercisesBasedOnAssessment.map(
                                  (rec: any, index: number) => {
                                    if (rec.vbTestLookupId === 35) {
                                      return (
                                        <span
                                          key={index}
                                          className={
                                            rec.mobility === "high"
                                              ? "ex-green"
                                              : rec.mobility === "medium"
                                                ? "ex-orange"
                                                : rec.mobility === "low" ||
                                                    rec.mobility === "ultralow"
                                                  ? "ex-red"
                                                  : ""
                                          }
                                        ></span>
                                      );
                                    }
                                  },
                                )}
                              </li>
                            )}
                            {exercise.testExercises[0].ismCTSIB && (
                              <li>
                                mCTSIB
                                {exercisesList.recommendedExercisesBasedOnAssessment.map(
                                  (rec: any, index: number) => {
                                    if (rec.vbTestLookupId === 1) {
                                      return (
                                        <span
                                          key={index}
                                          className={
                                            rec.mobility === "high"
                                              ? "ex-green"
                                              : rec.mobility === "medium"
                                                ? "ex-orange"
                                                : rec.mobility === "low" ||
                                                    rec.mobility === "ultralow"
                                                  ? "ex-red"
                                                  : ""
                                          }
                                        ></span>
                                      );
                                    }
                                  },
                                )}
                              </li>
                            )}
                            {exercise.testExercises[0].isTug && (
                              <li>
                                Tug
                                {exercisesList.recommendedExercisesBasedOnAssessment.map(
                                  (rec: any, index: number) => {
                                    if (rec.vbTestLookupId === 31) {
                                      return (
                                        <span
                                          key={index}
                                          className={
                                            rec.mobility === "high"
                                              ? "ex-green"
                                              : rec.mobility === "medium"
                                                ? "ex-orange"
                                                : rec.mobility === "low" ||
                                                    rec.mobility === "ultralow"
                                                  ? "ex-red"
                                                  : ""
                                          }
                                        ></span>
                                      );
                                    }
                                  },
                                )}
                              </li>
                            )}
                            {exercise.testExercises[0].isReach && (
                              <li>
                                Reach
                                {exercisesList.recommendedExercisesBasedOnAssessment.map(
                                  (rec: any, index: number) => {
                                    if (rec.vbTestLookupId === 2) {
                                      return (
                                        <span
                                          key={index}
                                          className={
                                            rec.mobility === "high"
                                              ? "ex-green"
                                              : rec.mobility === "medium"
                                                ? "ex-orange"
                                                : rec.mobility === "low" ||
                                                    rec.mobility === "ultralow"
                                                  ? "ex-red"
                                                  : ""
                                          }
                                        ></span>
                                      );
                                    }
                                  },
                                )}
                              </li>
                            )}
                          </ul>
                        </div>
                      </div>
                    )}
                  <div
                    className={
                      selectedExerciseId.includes(exercise.testExercises[0].id)
                        ? "exercise-main-card-wrap selected"
                        : "exercise-main-card-wrap"
                    }
                    onClick={(e) =>
                      handleCardClick(e, exercise.testExercises[0].id)
                    }
                  >
                    <div
                      className="q-mark-icon"
                      onClick={() => showExerciseDetailModal(exercise)}
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle
                          cx="10"
                          cy="10"
                          r="9.05"
                          fill="white"
                          stroke="#31344E"
                          strokeWidth="1.9"
                        />
                        <path
                          d="M10.508 12.3391H8.46477C8.47011 11.8583 8.50751 11.4444 8.57695 11.0971C8.65173 10.7446 8.77727 10.4267 8.95355 10.1436C9.13517 9.8605 9.37555 9.58006 9.6747 9.30228C9.92576 9.07793 10.1448 8.86425 10.3317 8.66126C10.5187 8.45827 10.6656 8.24994 10.7724 8.03627C10.8793 7.81725 10.9327 7.5742 10.9327 7.30711C10.9327 6.99728 10.8846 6.74088 10.7885 6.53789C10.6977 6.32956 10.5588 6.17197 10.3718 6.06513C10.1902 5.9583 9.96048 5.90488 9.68271 5.90488C9.45301 5.90488 9.23934 5.95563 9.04169 6.05712C8.84404 6.15327 8.68111 6.30285 8.55291 6.50584C8.43005 6.70883 8.36595 6.97592 8.36061 7.30711H6.03691C6.05293 6.57528 6.2212 5.97165 6.54171 5.49623C6.86756 5.01547 7.30292 4.66023 7.84779 4.43053C8.39266 4.19549 9.0043 4.07797 9.68271 4.07797C10.4306 4.07797 11.0716 4.20084 11.6058 4.44656C12.1399 4.68694 12.5486 5.04217 12.8317 5.51226C13.1148 5.97699 13.2564 6.54323 13.2564 7.21096C13.2564 7.6757 13.1656 8.08969 12.984 8.45293C12.8023 8.81084 12.5646 9.1447 12.2708 9.45453C11.977 9.76435 11.6538 10.0849 11.3013 10.4161C10.9968 10.6885 10.7885 10.9743 10.6763 11.2734C10.5695 11.5726 10.5134 11.9278 10.508 12.3391ZM8.22439 14.8151C8.22439 14.4732 8.34191 14.1901 8.57695 13.9657C8.81199 13.736 9.12716 13.6212 9.52245 13.6212C9.91241 13.6212 10.2249 13.736 10.4599 13.9657C10.7003 14.1901 10.8205 14.4732 10.8205 14.8151C10.8205 15.1462 10.7003 15.4267 10.4599 15.6564C10.2249 15.8861 9.91241 16.0009 9.52245 16.0009C9.12716 16.0009 8.81199 15.8861 8.57695 15.6564C8.34191 15.4267 8.22439 15.1462 8.22439 14.8151Z"
                          fill="#31344E"
                        />
                      </svg>
                    </div>
                    <div className="img-sec">
                      <IonImg
                        src={exercise.testExercises[0].thumbnail}
                        placeholder={undefined}
                      ></IonImg>
                    </div>
                    <div className="text-sec">
                      <h2>{exercise.testName}</h2>
                    </div>
                  </div>
                </div>
              );
            })}
      </div>
    </>
  );
};
export default ExerciseCard;
